var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"basic-input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"focus":function($event){return _vm.$emit('focus')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }